import { render } from "./education-block.vue?vue&type=template&id=37c01423&scoped=true&lang=true"
import script from "./education-block.vue?vue&type=script&lang=js"
export * from "./education-block.vue?vue&type=script&lang=js"

import "./education-block.vue?vue&type=style&index=0&id=37c01423&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c01423"]])

export default __exports__